import React, { Fragment, forwardRef } from 'react';
import LoadingBackdrop from '../../../LoadingBackdrop/LoadingBackdrop.js';
import { getCombineRemark, getObjectContent } from '../../../../utils/formatGPT/formatGPT';
import { vertexGenerateWithTextStreaming } from '../../../../store/vertex/vertex';
import { handleError, validateGPTQuota, decreaseGPTQuota } from '../../../../utils/openai';
import { tracking } from '../../../../utils/tracking';
import { trackDirect } from '../../../../store/analytics/api';
const promptIdentifier = 'product_recommendation_for_chubb';

export const GPTProductRecommendationButton = forwardRef(
  (
    {
      /** @type {()=>void} */ onStart,
      /** @type {()=>void} */ onFinish,
      /** @type {(object[])=>void} */ onComplete,
      /** @type {()=>void} */ onFail,
      /** @type {(bool) => void} */ loadingControl,
      /** @type {object} */ client,
      /** @type {string} */ remark,
      /** @type {any} */ toggleControl,
      /** @type {bool} */ useErrorHandling = true,
      /** @type {bool} */ useDrawer = true,
      /** @type {bool} */ useLoadingBackdrop = false,
      /** @type {React.ReactNode} */ children,
      /** @type {bool} */ useSampleData = false,
      /** @type {string} */ language
    },
    ref
  ) => {
    const [loading, setLoading] = React.useState(false);

    const handleComplete = result => {
      onFinish?.();
      const jsonResult = getObjectContent(result);
      // console.log('result:', jsonResult);
      if (jsonResult.error) {
        handleError(jsonResult.error, true);
      } else if (result && useDrawer) {
        onComplete?.(jsonResult);
        decreaseGPTQuota();
        toggleControl('gptProductRecommendationDrawer', {
          showSendButton: false,
          result: jsonResult,
          client: client,
          open: true
        });
      }
    };
    const handleCheckAndSend = async () => {
      onStart?.();
      loadingControl?.(true);
      if (useLoadingBackdrop) {
        setLoading(loading);
      }
      try {
        validateGPTQuota();
        trackDirect('useAiFeature');
        trackDirect('generateProductRecommendation');
        tracking('AI: Generate Product Recommendation');
        const combinedRemark = getCombineRemark(remark ?? client.factsheetId.remark);
        // console.log("combinedRemark:", combinedRemark);
        const advisorProfile = client.factsheetId;
        const profile = {
          name: advisorProfile.name,
          gender: advisorProfile.gender,
          age: advisorProfile.age,
          marriage_status: advisorProfile.marriage_status,
          child_count: advisorProfile.child_count,
          monthly_income: advisorProfile.monthly_income,
          monthly_expense: advisorProfile.monthly_expense,
          is_smoker: advisorProfile.is_smoker,
          total_saveing_insurance_coverage: advisorProfile.total_saveing_insurance_coverage,
          total_critical_illness_insurance_coverage: advisorProfile.total_critical_illness_insurance_coverage,
          total_life_insurance_coverage: advisorProfile.total_life_insurance_coverage,
          total_medical_insurance_policy_count: client.factsheetId.total_medical_insurance_policy_count,
          total_outstanding_loan: advisorProfile.total_outstanding_loan,
          liquid_asset: advisorProfile.liquid_asset,
          client_tags: advisorProfile.client_tags,
          personality: advisorProfile.personality,
          language: language,
          remark: combinedRemark?.remark
        };
        // console.log('button> get gpt product recommendation, profile:', profile);

        await vertexGenerateWithTextStreaming(
          promptIdentifier,
          profile,
          [],
          null,
          handleComplete,
          loading => {
            loadingControl?.(loading);
            if (useLoadingBackdrop) {
              setLoading(loading);
            }
          }
        );
      } catch (error) {
        onFail?.();
        loadingControl?.(false);
        if (useLoadingBackdrop) {
          setLoading(false);
        }
        if (useErrorHandling) {
          handleError(error, true);
        }
        return;
      }
    };

    ref.current = { handleCheckAndSend: handleCheckAndSend };
    return (
      <Fragment>
        {useLoadingBackdrop && <LoadingBackdrop open={loading} />}
        {children}
      </Fragment>
    );
  }
);
